const gaTabPath = 'educationHub.aboutGATabLabels.';

const gaTrans = {
    IDENTIFYING_GA_LABEL: gaTabPath + 'identifyingGA',
    CURRENT_CHALLENGE_LABEL: gaTabPath + 'currentChallenge',
    PATIENT_IMPACTS_LABEL: gaTabPath + 'impactOnPatients',
    COMPLEMENT_PATHWAY_LABEL: gaTabPath + 'complementPathway',
}

export default gaTrans